import { Component } from '@angular/core';
import { ContextService } from '@core/services/core/context.service';


@Component({
  selector: 'mapfre-footer-sinister',
  template: `<ng-container *ngIf="!ctx.isApp"><mapfre-footer></mapfre-footer></ng-container>`,
})
export class MapfreFooterSinisterComponent {

  constructor(
    public ctx: ContextService,
  ) {}
}
